import { SelectOption } from '@kep-ui-kit/ui-components';

export const packageStatusOptions: SelectOption[] = [
  { text: 'Enabled', value: '0' },
  { text: 'Pending', value: '1' },
  { text: 'Disabled', value: '2' },
];
